<template>
  <div style="font-size: 12px;">
        <div style="width: 100%; text-align: left; margin-top: -40px;">
            <h2>Price Break-Up: {{rowData.tailoring_detail !== null && rowData.tailoring_item_id.id>0 ? rowData.tailoring_detail.template_name : rowData.retail_detail !== null ? (rowData.retail_detail.sku_code+', '+rowData.retail_detail.article_name) : ''}}</h2>        
        </div>
        <div style="display: flex; flex-direction: column;">
            <div style="display: flex; flex-direction: column;">
                <div
                :style="'border-top: 1px solid #e2e2e2; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;'">
                    <div v-if="rowData.tailoring_item_id>0" style="padding-bottom: 5px; margin-top: 20px; border-bottom: 1px solid #e2e2e2; width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                        <div style="width: 20%; text-align: left;">
                            Stitching:
                        </div>
                        <div style="width: 50%; text-align: left;">
                            <el-input @focus="$event.target.select()"
                                :disabled="!$store.getters.getUserGroupAlerts.alter_net_sale_total"
                                @keyup.enter.native="$emit('closed')"
                                v-model="rowData.tailoring_unit_rate"
                                type="number"
                                size="small"
                                style="width: 85%;">
                                <template slot="append">{{getCurrencyFormat.currency_symbol}}</template>
                            </el-input>
                            <!--{{formatCurrency(parseFloat(rowData.tailoring_unit_rate))}} x {{rowData.tailoring_qty}} qty-->
                        </div>
                        <div style="width: 35%; text-align: right;">
                             x {{rowData.tailoring_qty}} qty = {{formatCurrency(parseFloat(rowData.tailoring_unit_rate)*rowData.tailoring_qty)}} <a href="javascript:void(0)" @click="show_tailoring_discount = true" style="color: red; font-size: 10px; text-decoration: underline;">- {{formatCurrency(rowData.tailoring_unit_discount_amount)}}</a>
                             <el-input 
                                v-if="show_tailoring_discount"
                                @focus="$event.target.select()"
                                @keyup.enter.native="$emit('closed')"
                                :disabled="!$store.getters.getUserGroupAlerts.override_sales_discount"
                                v-model="rowData.tailoring_detail.discount_percent"
                                type="number"
                                size="small"
                                style="width: 85%;">
                                <template slot="append">%</template>
                            </el-input>
                        </div>
                    </div>
                    <div v-if="rowData.tailoring_item_id>0 && parseFloat(rowData.extra_charge_unit_rate)>0" style="padding-bottom: 5px; border-bottom: 1px solid #e2e2e2; margin-top: 5px; width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                        <div style="width: 20%; text-align: left;">
                            Extras:
                        </div>
                        <div style="width: 50%; text-align: center;">
                            {{formatCurrency(parseFloat(rowData.extra_charge_unit_rate))}} x {{rowData.tailoring_qty}} qty
                        </div>
                        <div style="width: 35%; text-align: right;">
                            {{formatCurrency(parseFloat(rowData.extra_charge_unit_rate)*rowData.tailoring_qty)}} <span v-if="rowData.extra_charge_unit_discount_amount>0" style="color: red; font-size: 10px;">- {{formatCurrency(rowData.extra_charge_unit_discount_amount)}}</span>
                        </div>
                    </div>
                    <div v-if="rowData.tailoring_item_id>0 && rowData.fabric_id>0" style="padding-bottom: 5px; border-bottom: 1px solid #e2e2e2; margin-top: 5px; width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                        <div style="width: 20%; text-align: left;">
                            Fabric:
                        </div>
                        <div style="width: 50%; text-align: left;">
                            <el-input @focus="$event.target.select()"
                                :disabled="!$store.getters.getUserGroupAlerts.alter_net_sale_total || (rowData.tailoring_detail.fabric_sales_price_remains_flat === 1 
                                    || rowData.fabric_detail.stitching_rate_flat 
                                        || (rowData.fabric_detail.fabric_price_category_id !== null && rowData.fabric_detail.fabric_price_category_id>0))"
                                @keyup.enter.native="$emit('closed')"
                                v-model="rowData.fabric_unit_rate"
                                type="number"
                                size="small"
                                style="width: 85%;">
                                <template slot="append">{{getCurrencyFormat.currency_symbol}}</template>
                            </el-input>
                            <!--({{rowData.fabric_unit_qty}} {{rowData.fabric_detail.unit_name}} x {{formatCurrency(parseFloat(rowData.fabric_unit_rate))}}) x {{rowData.tailoring_qty}}  qty-->
                        </div>
                        <div style="width: 35%; text-align: right;">
                            {{rowData.tailoring_qty}} x {{rowData.fabric_unit_qty}} {{rowData.fabric_detail.unit_name}} = {{formatCurrency((parseFloat(rowData.fabric_unit_qty)*parseFloat(rowData.fabric_unit_rate)*rowData.tailoring_qty))}} 
                            <a href="javascript:void(0)" @click="show_fabric_discount = true" style="color: red; font-size: 10px; text-decoration: underline;">- {{formatCurrency((rowData.fabric_unit_discount_amount*parseFloat(rowData.fabric_unit_qty))*rowData.tailoring_qty)}}</a>
                            <el-input 
                                v-if="show_fabric_discount"
                                @focus="$event.target.select()"
                                @keyup.enter.native="$emit('closed')"
                                :disabled="!$store.getters.getUserGroupAlerts.override_sales_discount"
                                v-model="rowData.fabric_detail.discount_percent"
                                type="number"
                                size="small"
                                style="width: 85%;">
                                <template slot="append">%</template>
                            </el-input>
                        </div>
                    </div>
                    <div v-if="rowData.retail_item_id>0" style="padding-bottom: 5px; margin-top: 20px; border-bottom: 1px solid #e2e2e2; width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                        <div style="width: 20%; text-align: left;">
                            Unit Rate:
                        </div>
                        <div style="width: 50%; text-align: center;">
                            {{formatCurrency(parseFloat(rowData.retail_unit_rate))}} x {{rowData.retail_qty}} {{rowData.retail_detail.unit_name}}
                        </div>
                        <div style="width: 35%; text-align: right;">
                            {{formatCurrency(parseFloat(rowData.retail_unit_rate)*rowData.retail_qty)}} <span v-if="rowData.retail_unit_discount_amount>0" style="color: red; font-size: 10px;">- {{formatCurrency(rowData.retail_unit_discount_amount)}}</span>
                        </div>
                    </div>

                    <div v-if="rowData.tailoring_item_id>0 && rowData.fabric_id>0" style="padding-bottom: 5px; margin-top: 20px; border-bottom: 1px solid #e2e2e2; width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                        <div style="width: 25%; text-align: left;">
                            Sub-Total:
                        </div>
                        <div v-if="rowData.tailoring_item_id>0" style="width: 45%; text-align: center;">
                            {{parseFloat(rowData.tailoring_qty)}} qty
                        </div>

                        <div style="width: 35%; text-align: right;">
                            {{formatCurrency(parseFloat(rowData.taxable_total)+parseFloat(rowData.discount_amount))}} <span v-if="rowData.discount_amount>0" style="color: red; font-size: 10px;">- {{formatCurrency(rowData.discount_amount)}}</span>
                        </div>
                    </div>
                    <div style="margin-top: 15px; width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                        <div style="width: 25%; text-align: left;">
                            Extra Charges:
                        </div>
                        <div style="width: 75%; text-align: right;">
                            <el-input @focus="$event.target.select()"
                                @keyup.enter.native="$emit('closed')"
                                v-model="rowData.extra_amount"
                                type="number"
                                :min="0"
                                size="small"
                                style="width: 60%;">
                                <template slot="append">{{getCurrencyFormat.currency_symbol}}</template>
                            </el-input>
                        </div>
                    </div>
                    <div style="padding-bottom: 5px; margin-top: 10px; border-bottom: 1px solid #e2e2e2; width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                        <div style="width: 25%; text-align: left;">
                            Reason:
                        </div>
                        <div style="width: 75%; text-align: right;">
                            <el-input @focus="$event.target.select()"
                                v-model="rowData.extra_amount_reason"
                                @keyup.enter.native="$emit('closed')"
                                size="small"
                                style="width: 60%;">
                            </el-input>
                        </div>
                    </div>
                    <div style="margin-top: 15px; width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                        <div style="width: 25%; text-align: left; top: 5px; position: relative;">
                            Discount:
                        </div>
                        <div style="width: 75%; text-align: right;">
                            <el-input @focus="$event.target.select()"
                                :disabled="!$store.getters.getUserGroupAlerts.override_sales_discount || $store.getters.getSaleMasterDataProps.discount_coupon_id>0"
                                @keyup.enter.native="$emit('closed')"
                                v-model="rowData.discount_percent"
                                type="number"
                                size="small"
                                style="width: 60%;">
                                <template slot="append">%</template>
                            </el-input>
                        </div>
                    </div>
                    <div style="margin-top: 5px; margin-bottom: 15px; width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                        <div style="width: 25%; text-align: left; top: 5px; position: relative;">
                            Discount:
                        </div>
                        <div style="width: 75%; text-align: right;">
                            <el-input @focus="$event.target.select()"
                                :disabled="!$store.getters.getUserGroupAlerts.override_sales_discount || $store.getters.getSaleMasterDataProps.discount_coupon_id>0"
                                @keyup.enter.native="$emit('closed')"
                                v-model="rowData.discount_amount"
                                type="number"
                                size="small"
                                style="width: 60%;">
                                <template slot="append">{{getCurrencyFormat.currency_symbol}}</template>
                            </el-input>
                        </div>
                    </div>
                    
                    <div style="padding-bottom: 5px; border-bottom: 1px solid #e2e2e2; margin-top: 5px; width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                        <div style="width: 25%; text-align: left;">
                            <b>{{$store.getters.getSaleMasterDataProps.tax_id>0 ? 'Taxable ' : 'Sub-'}}Total: ({{getCurrencyFormat.currency_symbol}})</b>
                        </div>
                        <div style="width: 45%; text-align: center;">
                            <span v-html="'&nbsp;'"></span>
                        </div>
                        <div style="width: 35%; text-align: right;">
                            <b v-if="!$store.getters.getUserGroupAlerts.alter_net_sale_total">{{formatCurrency((parseFloat(rowData.taxable_total)))}}</b>
                            <el-input 
                                :disabled="!$store.getters.getUserGroupAlerts.alter_net_sale_total || (
                                    (rowData.tailoring_detail !==null && rowData.tailoring_detail.discount_percent !== undefined && rowData.tailoring_detail.discount_percent>0) 
                                    || (rowData.fabric_detail !==null && rowData.fabric_detail.discount_percent !== undefined && rowData.fabric_detail.discount_percent>0) 
                                        || (rowData.retail_detail !==null && rowData.retail_detail.discount_percent !== undefined && rowData.retail_detail.discount_percent>0))"
                                
                                v-else
                                :precision="2"
                                @focus="$event.target.select()"
                                :id="'taxable_total_'+rowData.sl_no"
                                @keyup.enter.native="editNetTotal(1)"
                                v-model="rowData.taxable_total"
                                type="number"
                                size="small"
                                style="width: 100%;">
                                <el-button :disabled="!$store.getters.getUserGroupAlerts.alter_net_sale_total || (
                                    (rowData.tailoring_detail !==null && rowData.tailoring_detail.discount_percent !== undefined && rowData.tailoring_detail.discount_percent>0) 
                                    || (rowData.fabric_detail !==null && rowData.fabric_detail.discount_percent !== undefined && rowData.fabric_detail.discount_percent>0) 
                                        || (rowData.retail_detail !==null && rowData.retail_detail.discount_percent !== undefined && rowData.retail_detail.discount_percent>0))"
                                 @click="editNetTotal(1)" slot="append" size="small" style="top: -1px; position: relative;">OK</el-button>
                            </el-input>
                        </div>
                        
                    </div>

                    <div 
                        v-if="$store.getters.getSaleMasterDataProps.tax_id>0"
                        style="padding-bottom: 5px; border-bottom: 1px solid #e2e2e2; margin-top: 5px; width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                        <div style="width: 25%; text-align: left;">
                            {{$store.getters.isIndiaTax ? 'GST (%)' : $store.getters.getSaleMasterDataProps.tax_detail.tax_name+' (%)'}}:
                        </div>
                        <div style="width: 45%; text-align: center;">
                            {{rowData.tax_percent}}%
                        </div>
                        <div style="width: 35%; text-align: right;">
                            {{formatCurrency((parseFloat(rowData.tax_amount))) }}
                        </div>
                    </div>

                    <div style="padding-bottom: 5px; border-bottom: 1px solid #e2e2e2; margin-top: 5px; width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                        <div style="width: 25%; text-align: left;">
                            <b>Net Total ({{getCurrencyFormat.currency_symbol}}):</b>
                        </div>
                        <div style="width: 45%; text-align: center;">
                            <span v-html="'&nbsp;'"></span>
                        </div>
                        <div style="width: 35%; text-align: right;">
                            <b>{{formatCurrency((parseFloat(rowData.net_total)))}}</b>
                        </div>
                    </div>

                    <div v-if="getBillingCurrency.length>0" style="padding-top: 5px; border-bottom: 1px solid #e2e2e2; padding-bottom: 10px; margin-top: 5px; width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                        <div style="width: 45%; text-align: left; top: 5px; position: relative;">
                            <b style="font-size: 18px;">Override Net Total: ({{getBillingCurrency[0].currency_short}})</b>
                        </div>
                        <div style="width: 5%; text-align: center;">
                            <span v-html="'&nbsp;'"></span>
                        </div>
                        <div style="width: 50%; text-align: right;">
                            <el-input @focus="$event.target.select()"
                                :disabled="!$store.getters.getUserGroupAlerts.alter_net_sale_total || (
                                    (rowData.tailoring_detail !==null && rowData.tailoring_detail.discount_percent !== undefined && rowData.tailoring_detail.discount_percent>0) 
                                    || (rowData.fabric_detail !==null && rowData.fabric_detail.discount_percent !== undefined && rowData.fabric_detail.discount_percent>0) 
                                        || (rowData.retail_detail !==null && rowData.retail_detail.discount_percent !== undefined && rowData.retail_detail.discount_percent>0))"
                                :id="'alter_net_total_'+rowData.sl_no"
                                @keyup.enter.native="editNetTotal"
                                v-model="rowData.alter_net_total"
                                type="number"
                                size="small"
                                style="width: 100%;">
                                <el-button :disabled="!$store.getters.getUserGroupAlerts.alter_net_sale_total || (
                                    (rowData.tailoring_detail !==null && rowData.tailoring_detail.discount_percent !== undefined && rowData.tailoring_detail.discount_percent>0) 
                                    || (rowData.fabric_detail !==null && rowData.fabric_detail.discount_percent !== undefined && rowData.fabric_detail.discount_percent>0) 
                                        || (rowData.retail_detail !==null && rowData.retail_detail.discount_percent !== undefined && rowData.retail_detail.discount_percent>0))"
                                 @click="editNetTotal" slot="append" size="small" style="top: -1px; position: relative;">OK</el-button>
                            </el-input>
                        </div>
                    </div>
                     <div v-else style="padding-top: 5px; border-bottom: 1px solid #e2e2e2; padding-bottom: 10px; margin-top: 5px; width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                        <div style="width: 45%; text-align: left; top: 5px; position: relative;">
                            <b style="font-size: 18px;">Override Net Total: ({{getCurrencyFormat.currency_symbol}})</b>
                        </div>
                        <div style="width: 5%; text-align: center;">
                            <span v-html="'&nbsp;'"></span>
                        </div>
                        <div style="width: 50%; text-align: right;">
                            <el-input @focus="$event.target.select()"
                                :disabled="!$store.getters.getUserGroupAlerts.alter_net_sale_total || (
                                    (rowData.tailoring_detail !==null && rowData.tailoring_detail.discount_percent !== undefined && rowData.tailoring_detail.discount_percent>0) 
                                    || (rowData.fabric_detail !==null && rowData.fabric_detail.discount_percent !== undefined && rowData.fabric_detail.discount_percent>0) 
                                        || (rowData.retail_detail !==null && rowData.retail_detail.discount_percent !== undefined && rowData.retail_detail.discount_percent>0))"
                                :id="'alter_net_total_'+rowData.sl_no"
                                @keyup.enter.native="editNetTotal"
                                v-model="rowData.alter_net_total"
                                type="number"
                                size="small"
                                style="width: 100%;">
                                <el-button :disabled="!$store.getters.getUserGroupAlerts.alter_net_sale_total || (
                                    (rowData.tailoring_detail !==null && rowData.tailoring_detail.discount_percent !== undefined && rowData.tailoring_detail.discount_percent>0) 
                                    || (rowData.fabric_detail !==null && rowData.fabric_detail.discount_percent !== undefined && rowData.fabric_detail.discount_percent>0) 
                                        || (rowData.retail_detail !==null && rowData.retail_detail.discount_percent !== undefined && rowData.retail_detail.discount_percent>0))"
                                 @click="editNetTotal" slot="append" size="small" style="top: -1px; position: relative;">OK</el-button>
                            </el-input>
                        </div>
                    </div>

                </div>

            </div>
            
            <el-button 
                @click="$emit('closed')"
                size="small" 
                type="primary" 
                style="width: 70px; height: 30px; margin-top: 20px;">
                Cancel
            </el-button>
        </div>
  </div>
</template>

<script>
export default {
    props: ['rowData'],
    data() {
        return {
            show_tailoring_discount: false,
            show_fabric_discount: false
        }
    },
    computed: {
        getBillingCurrency() {
            if(this.$store.state.saleMaster.props.billing_currency_id !== null) {
                return this.$store.getters.getCountryList.filter(t => t.id === this.$store.state.saleMaster.props.billing_currency_id)
            }
            return []
        },
        getCombinationItems() {
            let list = this.rowData.combination_item_list

            list.forEach(element => {
                let tailoringItemIndex = this.rowData.tailoring_detail.combination_items.findIndex((t) => t.id === element.tailoring_item_id)
                if(tailoringItemIndex>=0) {
                    element.tailoring_item_name = this.rowData.tailoring_detail.combination_items[tailoringItemIndex].template_name
                }
            })

            return list
        }
    },
    methods: {
        editNetTotal(source=0) {
            
            if(this.$store.state.saleMaster.props.billing_currency_id>0 && this.$store.state.saleMaster.props.exchange_rate>0) {
                this.rowData.alter_net_total = (this.rowData.alter_net_total*this.$store.state.saleMaster.props.exchange_rate).toFixed(2)
            }

            let rowData = this.rowData

            let taxPercent = parseFloat(this.rowData.tax_percent)
            let alter_net_sale_total = parseFloat(this.rowData.alter_net_total)

            let totalAmountBeforeTax = 0

            if(source === 1) {
                let taxable_total = parseFloat(this.rowData.taxable_total)
                alter_net_sale_total = taxable_total + ((taxable_total*taxPercent)/100)
            }

            totalAmountBeforeTax = alter_net_sale_total-((alter_net_sale_total/(100+taxPercent))*taxPercent)
            
            if(parseFloat(rowData.retail_item_id)>0) {
                rowData.tailoring_unit_rate = 0
                rowData.tailoring_qty = 0
                rowData.fabric_unit_rate = 0
                rowData.fabric_unit_qty = 0
            } else if(parseFloat(rowData.tailoring_item_id)>0) {
                rowData.retail_qty = 0
            }

            rowData.discount_amount = 0
            rowData.discount_percent = 0
            rowData.extra_amount = 0
            rowData.extra_amount_reason = ""
            rowData.extra_charge_unit_rate = 0
            rowData.extra_charge_unit_discount_amount = 0

            let tailoring_unit_rate = parseFloat(rowData.tailoring_unit_rate)  
            let tailoring_qty = parseInt(rowData.tailoring_qty)  
            let totalTailoringPrice = tailoring_unit_rate*parseFloat(tailoring_qty)

            let fabric_unit_rate = parseFloat(rowData.fabric_unit_rate)    
            let fabric_unit_qty = parseFloat(rowData.fabric_unit_qty)
            let totalFabricPrice = (fabric_unit_rate*(fabric_unit_qty*tailoring_qty))

            if(fabric_unit_qty>0) {
                let priceForFabric = totalAmountBeforeTax-totalTailoringPrice                
                totalFabricPrice = priceForFabric

                rowData.fabric_unit_rate = totalFabricPrice/(fabric_unit_qty*tailoring_qty)
            } else if(tailoring_qty>0) {
                rowData.tailoring_unit_rate = totalAmountBeforeTax/tailoring_qty
            } else if(rowData.retail_qty>0) {
                rowData.retail_unit_rate = totalAmountBeforeTax/parseFloat(rowData.retail_qty)
            }

            this.rowData.alter_net_total = 0
            if(this.$store.state.preferences.props.sale_step_post_qty === 2) {
                    
                let itemType = rowData.tailoring_item_id>0 ? 0 : 2
                if(document.getElementById('item_search_field'+itemType)) {
                    this.changeFocus('item_search_field'+itemType)
                } else {
                    this.changeFocus('item_search_field')
                }
                
            } else {
                this.changeFocus('item_search_field')
            }

            this.$emit('closed')
        },

    },
    mounted() {
        setTimeout(() => {

            this.rowData.taxable_total = parseFloat(this.rowData.taxable_total).toFixed(2)
            this.rowData.fabric_unit_rate = parseFloat(this.rowData.fabric_unit_rate).toFixed(2)
            
            if(this.rowData.tax_percent>0) {
                
            } else {
                
            }
            //document.getElementById('alter_net_total_'+(this.rowData.sl_no)).focus();
            document.getElementById('taxable_total_'+(this.rowData.sl_no)).focus();
        }, 300);
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/SaleMaster/Form/OrderItem/EditPrice.vue